(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  function applyPickupClosedState() {
    const list = document.querySelector('results-list[data-pickup-closed]');
    if (!list) return;

    const isClosed = list.getAttribute('data-pickup-closed') === 'true';

    // ✅ Save the closed state in localStorage by collection handle
    const handle = window.location.pathname.split("/collections/")[1]?.split("/")[0];
    if (handle) {
      // Always remember last restaurant seen (useful fallback)
      localStorage.setItem("last_restaurant_handle", handle);

      if (isClosed) {
        localStorage.setItem(`pickup_closed:${handle}`, "true");
      } else {
        localStorage.removeItem(`pickup_closed:${handle}`);
      }
    }

    if (!isClosed) return;

    // Disable buttons on collection grid
    document.querySelectorAll('button[name="add"], button[type="submit"][name="add"]').forEach((btn) => {
      btn.disabled = true;
      btn.setAttribute('aria-disabled', 'true');
      btn.classList.add('is-pickup-closed-disabled');
    });

    // Block /cart/add submits (in case something slips through)
    document.querySelectorAll('form[action^="/cart/add"], form[action*="/cart/add"]').forEach((form) => {
      form.addEventListener(
        'submit',
        (e) => {
          e.preventDefault();
          e.stopPropagation();
        },
        { capture: true }
      );
    });

    // Block click just in case
    document.addEventListener(
      'click',
      (e) => {
        const btn = e.target.closest('button[name="add"], button[type="submit"][name="add"]');
        if (btn) {
          e.preventDefault();
          e.stopPropagation();
        }
      },
      true
    );
  }

  // =========================================================
  // MAREMMA TO GO — Scrollspy: highlight active category chip
  // =========================================================
  function initMtgCategoryScrollSpy() {
    const bar = document.querySelector("[data-mtg-catbar]");
    if (!bar) return;

    const chips = Array.from(bar.querySelectorAll("[data-mtg-chip]"));
    const sections = Array.from(document.querySelectorAll("[data-mtg-section]"));
    if (!chips.length || !sections.length) return;

    const chipById = new Map();
    chips.forEach((chip) => {
      const href = chip.getAttribute("href") || "";
      const id = href.startsWith("#") ? href.slice(1) : "";
      if (id) chipById.set(id, chip);
    });

    function setActive(id) {
      chips.forEach((c) => c.classList.remove("is-active"));
      const chip = chipById.get(id);
      if (!chip) return;
      chip.classList.add("is-active");

      const container = bar.querySelector(".mtg-catbar__inner");
      if (container && chip.scrollIntoView) {
        chip.scrollIntoView({ behavior: "smooth", inline: "center", block: "nearest" });
      }
    }

    if (sections[0]?.id) setActive(sections[0].id);

    const io = new IntersectionObserver(
      (entries) => {
        const visible = entries
          .filter((e) => e.isIntersecting)
          .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];

        if (visible?.target?.id) setActive(visible.target.id);
      },
      {
        root: null,
        threshold: [0.2, 0.35, 0.5, 0.7],
        rootMargin: "-20% 0px -70% 0px",
      }
    );

    sections.forEach((sec) => io.observe(sec));

    chips.forEach((chip) => {
      chip.addEventListener("click", () => {
        const href = chip.getAttribute("href") || "";
        const id = href.startsWith("#") ? href.slice(1) : "";
        if (id) setActive(id);
      });
    });
  }

  document.addEventListener('DOMContentLoaded', applyPickupClosedState);
  document.addEventListener('shopify:section:load', applyPickupClosedState);
  document.addEventListener('shopify:section:reorder', applyPickupClosedState);
  document.addEventListener('shopify:section:select', applyPickupClosedState);

  document.addEventListener("DOMContentLoaded", initMtgCategoryScrollSpy);
  document.addEventListener("shopify:section:load", initMtgCategoryScrollSpy);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-list"] && !Shopify.designMode) return;
  try {
    
(function(){
  const root = document.querySelector('[data-testid="product-list"][data-pickup-closed]');
  if (!root) return;

  const isClosed = root.getAttribute('data-pickup-closed') === 'true';
  const handle = root.getAttribute('data-restaurant-handle') || '';

  // Remember last restaurant + closed state (useful for product pages logic later)
  if (handle) {
    localStorage.setItem('last_restaurant_handle', handle);
    if (isClosed) localStorage.setItem(`pickup_closed:${handle}`, 'true');
    else localStorage.removeItem(`pickup_closed:${handle}`);
  }

  if (!isClosed) return;

  // Disable add-to-cart buttons ONLY inside this section
  root.querySelectorAll('button[name="add"], button[type="submit"][name="add"]').forEach((btn) => {
    btn.disabled = true;
    btn.setAttribute('aria-disabled', 'true');
    btn.classList.add('is-pickup-closed-disabled');
  });

  // Block /cart/add submits inside this section
  root.querySelectorAll('form[action^="/cart/add"], form[action*="/cart/add"]').forEach((form) => {
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      e.stopPropagation();
    }, { capture: true });
  });

  // Defensive: block clicks on add buttons inside this section
  root.addEventListener('click', (e) => {
    const btn = e.target.closest && e.target.closest('button[name="add"], button[type="submit"][name="add"]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
  }, true);
})();

  } catch(e) { console.error(e); }
})();
})();
